var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuentActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuentActive);
export default __webpack_public_path__ + "static/media/DocuentActive.0f9c441ee6887639ae950bf737f82d90.svg";
export { ForwardRef as ReactComponent };